import { render } from "./museumLabor.vue?vue&type=template&id=447ece4c"
import script from "./museumLabor.vue?vue&type=script&lang=js"
export * from "./museumLabor.vue?vue&type=script&lang=js"

import "./museumLabor.vue?vue&type=style&index=0&id=447ece4c&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__